import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { preloadLaunchAssets } from './game/engine/spriteLoader'
import { initAudio } from './lib/audio'
import ErrorBoundary from './components/ui/ErrorBoundary'

preloadLaunchAssets()

document.addEventListener('click', () => { initAudio() }, { once: true })

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)
